import {
  FinancialsColumnDefinition,
  FinancialsRowDataType,
  FinancialsSubRowDataType,
} from '../../components/financials-table/types'
import type { DividendValueProperty } from './constants'

export interface DividendAnnual {
  Amount: number
  Estimate: boolean
  FiscalPeriod: string
  Payout: number
  Ticker: string
  Yield: number
}

export interface DividendsDataType extends Omit<FinancialsRowDataType, 'id' | 'values'> {
  id: DividendValueProperty
  values: Array<{ year: string; value: number | null; isEstimate: boolean }>
}

export interface Dividend {
  Exdate: string
  Ordinary: number
  Special: number
  Ticker: string
}

export interface DividendData {
  lastClose: number | null
  dividendExDate: string | null
  dividendEstimate: number | null
  dividendTTM: number | null
  dividendsAnnualData: DividendAnnual[]
  dividendsData: Dividend[]
}

export enum DividendDataEnum {
  yoyChange = 'yoyChange',
  yoyChangePct = 'yoyChangePct',
}

export type DividendSettings = {
  [DividendDataEnum.yoyChange]: boolean
  [DividendDataEnum.yoyChangePct]: boolean
}

export type DividendsColumnsType = {
  columns: FinancialsColumnDefinition<FinancialsRowDataType>[]
  subColumns: Record<DividendDataEnum, FinancialsColumnDefinition<FinancialsSubRowDataType>[]>
}
